import { SET_APPEAL_REELS } from "./types";

export const setAppealReels = (payload) => ({
  type: SET_APPEAL_REELS,
  payload,
});
